import React from 'react';
import {
    StyleSheet,
    View,
    TouchableOpacity,
    ScrollView,
    TouchableWithoutFeedback,
    ActivityIndicator,
    Platform
  } from 'react-native'
import stylesheet from './Style'
import MyText from './MyText';
import MyDatePicker from './MyDatePicker';
import MyTextInput from './MyTextInput';
import { MaterialIcons, Entypo, Feather } from '@expo/vector-icons'; 
import * as SecureStore from 'expo-secure-store';
import axios from 'axios';
import PRF from './assets/icons/PRF.svg';
import IndustrialWaste from './assets/icons/IndustrialWaste.svg';
import MySVG from './assets/MySVG';

import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';
import AsyncStorage from '@react-native-async-storage/async-storage';

const ResetPassword = (props) => {
    const css = stylesheet();

    const [password, setPassword] = React.useState({
        value: '',
        hasError: false
    });
    const [verifyPassword, setVerifyPassword] = React.useState('');

    const ResetPassword = async() => {
        console.log(password);
        if(!password.value.trim()){
            props.openModal('Warning', 'Please enter your email.');
            return;
        }
        if(password.hasError || !password.valid){
            props.openModal("Warning", "Password must contain at least 8 characters that include at least 1 lowercase character, 1 uppercase character, and 1 number.");
            return;
        }
        if(password.value != verifyPassword){
            props.openModal("Warning", "The passwords you entered do not match.");
            return;
        }
        const data = {
            password: password.value,
            token: props.token
        };
        console.log(data);
        axios.post('/api/user/resetPassword.php', data)
        .then(async(res) => {
            props.openModal('Success', 'Your password was successfully reset!');
            setTimeout(() => {
                props.navigation.push('Landing Page')
            },2000)
        })
        .catch((err) => {
            console.log(err.response);
            if(err.response?.status == 400){
                props.openModal('Warning', err.response.data);
            }
            else{
                props.openModal('Warning', 'An internal error occured. Please try again later or contact us.');
            }
        })
    }

  return (
    <View style={{alignItems: 'center', justifyContent: 'center', marginTop: Platform.OS==='web'?18:15, marginBottom: Platform.OS==='web'?13:0}}>
        <View style={{width: 232}}>
            <MyText style={[css.title, css.bold]}>
                Reset Password
            </MyText>
            <View style={{marginTop: 18, flexDirection: 'row'}}>
                <MyTextInput
                    style={[{flexGrow: 0, flexShrink: 0, flexBasis: 232}, css.formRowInput]}
                    onChangeText={(e) => {
                        setPassword(prev => ({
                                ...prev,
                                value: e
                            }))
                        }
                    }
                    onChangeTextImmediate={(e) => {
                            setPassword(prev => ({
                                ...prev,
                                value: e
                            }))
                        }
                    }
                    onChangeValidation={(e) => {
                        console.log(e);
                            setPassword(prev => ({
                                ...prev,
                                valid: e
                            }))
                        }
                    }
                    value={password.value}
                    hasError={password.hasError}
                    secureTextEntry={true}
                    autoCapitalize='none'
                    autoCorrect={false}
                    validation='password'
                    placeholder='Password'
                    fancyPlaceholder={true}
                />
            </View>
            <View style={{marginTop: 18, flexDirection: 'row'}}>
                <MyTextInput
                    style={[{flexGrow: 0, flexShrink: 0, flexBasis: 232}, css.formRowInput]}
                    onChangeText={(e) => {
                            setVerifyPassword(e)
                        }
                    }
                    onChangeTextImmediate={(e) => {
                            setVerifyPassword(e)
                        }
                    }
                    value={verifyPassword}
                    secureTextEntry={true}
                    autoCapitalize='none'
                    autoCorrect={false}
                    validation='verifyPassword'
                    password={password.value}
                    placeholder='Verify Password'
                    fancyPlaceholder={true}
                />
            </View>
            <View style={{marginTop: 18, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <TouchableOpacity onPress={() => ResetPassword()} style={{flexGrow: 0, flexShrink: 0, flexBasis: 135}}>
                    <MyText style={[css.button, css.bold]}>
                        Reset
                    </MyText>
                </TouchableOpacity>
            </View>
            <View style={{marginTop: 15, alignItems: 'center'}}>
                <TouchableOpacity onPress={() => props.navigation.push('Register')} style={{flexGrow: 0, flexShrink: 0}}>
                    {/* <View style={{borderStyle: Platform.OS==='ios'?'solid':'dotted', borderColor: '#461b6f', borderBottomWidth: 1}}> */}
                        {/* <MyText style={[css.bold, {fontSize: 10, color: '#461b6f', paddingBottom: 3}]}>
                            Register and Join Us!
                        </MyText> */}
                    {/* </View> */}
                    <View style={{ overflow: 'hidden' }}>
                        <View
                        style={{
                            borderStyle: 'dashed',
                            borderWidth: 1,
                            borderColor: '#461b6f',
                            margin: -2,
                            marginBottom: 10,
                            paddingHorizontal: 1
                        }}>
                        {/* https://stackoverflow.com/questions/73506925/when-trying-to-add-a-dashed-border-style-getting-unsupported-dashed-dotted-b */}
                        <MyText onPress={() => props.navigation.push('Landing Page')} style={[css.bold, css.s, {color: '#461b6f', paddingBottom: 3, textAlign: 'center'}]}>
                            Back to Login
                        </MyText>
                        {/* <View style={{ height: 1, width: 200 }} /> */}
                        </View>
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    </View>
  );
}

const styles = StyleSheet.create({

});

const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(ResetPassword)